
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[state]/[destination]/things-to-do",
      function () {
        return require("private-next-pages/destination/[state]/[destination]/things-to-do/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[state]/[destination]/things-to-do"])
      });
    }
  